module.exports = __webpack_public_path__ + "static/img/level-playing-field.377d579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/level-playing-field.png
// module id = qHDc
// module chunks = 0